(() => {
  if (window.aquaCountryPicker) { window.aquaCountryPicker.init(); return; }
  const flag = (code) => {
    const image = document.createElement('img');
    image.src = `https://cdn.shopify.com/static/images/flags/${code.toLowerCase()}.svg`;
    image.alt = '';
    image.width = 24;
    image.height = 24;
    image.loading = 'lazy';
    image.className = 'aqua-country-picker__flag';
    image.addEventListener('error', () => { image.style.visibility = 'hidden'; }, { once: true });
    return image;
  };
  const init = (root = document) => {
    root.querySelectorAll('[data-aqua-country-select], [data-aqua-footer-country-select]').forEach((select) => {
      if (select.dataset.flagPickerReady) return;
      select.dataset.flagPickerReady = 'true';
      const form = select.form;
      const isFooter = select.hasAttribute('data-aqua-footer-country-select');
      if (!form) return;
      const details = document.createElement('details');
      details.className = 'aqua-country-picker' + (isFooter ? ' aqua-country-picker--footer' : '');
      const summary = document.createElement('summary');
      summary.className = 'aqua-country-picker__trigger';
      summary.setAttribute('aria-label', select.getAttribute('aria-label') || 'Country/region');
      summary.setAttribute('aria-expanded', 'false');
      const selectedText = document.createElement('span');
      const caret = document.createElement('span');
      caret.className = 'aqua-country-picker__caret';
      caret.setAttribute('aria-hidden', 'true');
      summary.append(flag(select.value), selectedText, caret);
      const panel = document.createElement('div');
      panel.className = 'aqua-country-picker__panel';
      const search = document.createElement('input');
      search.type = 'search';
      search.placeholder = 'Search country';
      search.setAttribute('aria-label', 'Search countries');
      search.autocomplete = 'off';
      const list = document.createElement('div');
      list.className = 'aqua-country-picker__list';
      list.id = `${select.id}-flag-options`;
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', select.getAttribute('aria-label') || 'Country/region');
      summary.setAttribute('aria-controls', list.id);
      const empty = document.createElement('p');
      empty.className = 'aqua-country-picker__empty';
      empty.textContent = 'No countries found';
      empty.setAttribute('role', 'status');
      empty.hidden = true;
      const buttons = [...select.options].map((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'aqua-country-picker__option';
        button.setAttribute('role', 'option');
        button.dataset.code = option.value;
        button.dataset.search = `${option.dataset.countryName || ''} ${option.textContent}`.toLowerCase();
        const label = document.createElement('span');
        label.textContent = option.textContent;
        const name = document.createElement('small');
        name.textContent = option.dataset.countryName || '';
        if (!isFooter) label.append(name);
        const check = document.createElement('span');
        check.className = 'aqua-country-picker__check';
        check.textContent = '✓';
        check.setAttribute('aria-hidden', 'true');
        button.append(flag(option.value), label, check);
        button.addEventListener('click', () => {
          select.value = option.value;
          sync();
          details.open = false;
          summary.focus();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        list.append(button);
        return button;
      });
      const sync = () => {
        const selected = select.options[select.selectedIndex];
        if (!selected) return;
        selectedText.textContent = selected.textContent;
        summary.querySelector('img').replaceWith(flag(select.value));
        summary.title = selected.dataset.countryName || selected.textContent;
        buttons.forEach(button => button.setAttribute('aria-selected', String(button.dataset.code === select.value)));
      };
      const filter = () => {
        const query = search.value.trim().toLowerCase();
        buttons.forEach(button => { button.hidden = !button.dataset.search.includes(query); });
        empty.hidden = buttons.some(button => !button.hidden);
      };
      search.addEventListener('input', filter);
      panel.append(search, list, empty);
      details.append(summary, panel);
      select.insertAdjacentElement('afterend', details);
      form.classList.add(isFooter ? 'aqua-footer-localization--flags' : 'aqua-announcement__localization--flags');
      select.addEventListener('change', () => {
        sync();
        if (isFooter) form.submit();
      });
      sync();
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) { search.value = ''; filter(); search.focus(); }
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { event.preventDefault(); details.open = false; summary.focus(); return; }
        const visible = buttons.filter(button => !button.hidden);
        const index = visible.indexOf(document.activeElement);
        if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault();
          if (!details.open) { details.open = true; return; }
          const next = event.key === 'ArrowDown' ? (index + 1) % visible.length : (index <= 0 ? visible.length - 1 : index - 1);
          visible[next]?.focus();
        } else if (index >= 0 && ['Home', 'End'].includes(event.key)) {
          event.preventDefault();
          visible[event.key === 'Home' ? 0 : visible.length - 1]?.focus();
        }
      });
      // A document-scoped signal releases listeners when Theme Editor replaces this section.
      const controller = new AbortController();
      document.addEventListener('pointerdown', (event) => {
        if (!details.contains(event.target)) details.open = false;
      }, { signal: controller.signal });
      details.addEventListener('focusout', (event) => {
        if (!details.contains(event.relatedTarget)) details.open = false;
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(details)) controller.abort();
      }, { signal: controller.signal });
    });
  };
  window.aquaCountryPicker = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
